/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { Helmet } from 'polaris-coreweb/exports';

const getHelmetForSpec = (props) => {
  const {
    layoutData: {
      page: {
        title,
        url,
        vehicleSpecs: {
          name,
          summary: {
            doors,
            driveTrain,
            fuelDelivery,
            transmission,
            fuelType,
            CC,
            price,
            trim,
          },
        },
      },
    },
    metaData: {
      pageTitle: metaTitle,
      pageDescription: metaDescription,
    },
    config: {
      siteUrl,
    },
  } = props;

  let jsonld = {
    '@context': 'https://schema.org',
    '@type': 'Car',
    name: title || metaTitle,
    url: `${siteUrl}${url}`,
    description: metaDescription,
    manufacturer: name,
    brand: name,
    model: trim,
    vehicleTransmission: transmission,
    fuelType,
    numberOfDoors: doors,
    driveWheelConfiguration: driveTrain,
    fuelEfficiency: fuelDelivery,
    offers: {
      '@type': 'Offer',
      availability: 'http://schema.org/InStock',
      price,
      priceCurrency: 'GBP',
    },
  };

  if (CC) {
    jsonld = {
      ...jsonld,
      vehicleEngine: {
        '@type': 'EngineSpecification',
        enginePower: CC,
      },
    };
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
      <title>{title}</title>
    </Helmet>
  );
};

getHelmetForSpec.propTypes = {
  layoutData: PropTypes.shape({
    page: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
      vehicleSpecs: PropTypes.shape({
        name: PropTypes.string,
        summary: PropTypes.shape({
          doors: PropTypes.number,
          driveTrain: PropTypes.string,
          fuelDelivery: PropTypes.string,
          transmission: PropTypes.string,
          fuelType: PropTypes.string,
          CC: PropTypes.number,
          price: PropTypes.number,
          trim: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  metaData: PropTypes.shape({
    pageTitle: PropTypes.string,
    pageDescription: PropTypes.string,
  }).isRequired,
  config: PropTypes.shape({
    siteUrl: PropTypes.string,
  }).isRequired,
};

export default getHelmetForSpec;
